import { render, staticRenderFns } from "./FlagQrCodeExample.vue?vue&type=template&id=647bb798"
import script from "./FlagQrCodeExample.vue?vue&type=script&lang=js"
export * from "./FlagQrCodeExample.vue?vue&type=script&lang=js"
import style0 from "./FlagQrCodeExample.vue?vue&type=style&index=0&id=647bb798&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('647bb798')) {
      api.createRecord('647bb798', component.options)
    } else {
      api.reload('647bb798', component.options)
    }
    module.hot.accept("./FlagQrCodeExample.vue?vue&type=template&id=647bb798", function () {
      api.rerender('647bb798', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/identifiers/components/FlagQrCodeExample.vue"
export default component.exports